import { render, staticRenderFns } from "./Arret.vue?vue&type=template&id=4838c84a"
import script from "./Arret.vue?vue&type=script&lang=js"
export * from "./Arret.vue?vue&type=script&lang=js"
import style0 from "./Arret.vue?vue&type=style&index=0&id=4838c84a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports